import styled from 'styled-components';

export const SDetailHeaderButtonWrapper = styled.div`
  text-align: right;

  > * {
    margin: 0px 5px;
  }
`;
